module.exports = __webpack_public_path__ + "static/index/img/baikal-212.d0df5bdd.jpg";